import { render, staticRenderFns } from "./konfortify-fb.vue?vue&type=template&id=5f5ec30e&"
import script from "./konfortify-fb.vue?vue&type=script&lang=js&"
export * from "./konfortify-fb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports